import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-toastify/dist/ReactToastify.css'
import './utils/axiosConfig'
import App from './App'
import { store } from './app/store'
import { Provider } from 'react-redux'
import * as serviceWorker from './serviceWorker'
import Clarity from '@microsoft/clarity'
import * as Sentry from '@sentry/react'

// Initialize Sentry
Sentry.init({
  dsn: 'https://db696fe2187487e8b856923cfd1cbde3@o4509000083963904.ingest.us.sentry.io/4509493906833408',
  environment: process.env.NODE_ENV || 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    // Filter out localhost errors in production
    if (process.env.NODE_ENV === 'production' &&
        event.request?.url?.includes('localhost')) {
      return null
    }
    return event
  }
})

// Initialize Microsoft Clarity
Clarity.init('rywhd5r188')

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
